import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCallQueue = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    {...props}
  >
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M12.82 6.173c1.27 0 2.291 1.028 2.291 2.29a2.294 2.294 0 0 1-2.205 2.291.7.7 0 0 0-.17 0m4.681-3.257a1.83 1.83 0 0 1 1.832 1.832c0 .989-.785 1.795-1.764 1.831a.6.6 0 0 0-.136 0m-3.265 6.575a4 4 0 0 0 1.623-.72c1.291-.969 1.291-2.567 0-3.536-.456-.347-1.01-.58-1.598-.711m4.455 4.245c.476-.099.927-.291 1.297-.576 1.033-.774 1.033-2.052 0-2.827a3.3 3.3 0 0 0-1.277-.57m-13.78.614c-1.584 1.06-1.584 2.788 0 3.842 1.8 1.204 4.751 1.204 6.55 0 1.585-1.06 1.585-2.788 0-3.842-1.792-1.197-4.744-1.197-6.55 0m3.272-2.985a1 1 0 0 0-.216 0A2.893 2.893 0 0 1 5.066 7.77a2.903 2.903 0 0 1 2.906-2.905 2.903 2.903 0 0 1 .105 5.805'
    />
  </svg>
);
export default SvgCallQueue;
